import email from "../assets/email.png";
import mobile from "../assets/mobile.png";
import api from "../assets/api.png";
import cpp from "../assets/cpp.png";
import css from "../assets/css.png";
import figma from "../assets/figma.png";
import flutter from "../assets/flutter.png";
import git from "../assets/git.png";
import graphql from "../assets/graphql.png";
import html from "../assets/html.png";
import javascript from "../assets/javascript.png";
import mu5 from "../assets/mu5.png";
import node from "../assets/node.png";
import python from "../assets/python.png";
import react from "../assets/react.png";
import redux from "../assets/redux.png";
import sass from "../assets/sass.png";
import typescript from "../assets/typescript.png";
import vue from "../assets/vue.png";

import about01 from "../assets/about01.png";
import about02 from "../assets/about02.png";
import about03 from "../assets/about03.png";
import about04 from "../assets/about04.png";

import profile from "../assets/profile.png";
import circle from "../assets/circle.svg";
import logo from "../assets/logo.png";

import adidas from "../assets/adidas.png";
import amazon from "../assets/amazon.png";
import asus from "../assets/asus.png";
import bolt from "../assets/bolt.png";
import nb from "../assets/nb.png";
import skype from "../assets/skype.png";
import spotify from "../assets/spotify.png";
import whatsapp from "../assets/whatsapp.png";
import telegram from "../assets/telegram.png";
import call from "../assets/call.png";
import gmail from "../assets/gmail.png";

import eng_hindi_marathi_service from "../assets/ravindran_img/eng_hindi_marathi_service.jpg";
import building_name_board from "../assets/ravindran_img/building_name_board.jpg";
import building_name_board02 from "../assets/ravindran_img/building_name_board02.jpg";
import building_name_board01 from "../assets/ravindran_img/building_name_board01.jpg";
import building_name_board03 from "../assets/ravindran_img/building_name_board03.jpg";
import building_name_board04 from "../assets/ravindran_img/building_name_board04.jpg";
import banner from "../assets/ravindran_img/banner.jpg";
import sign_board_painter from "../assets/sign_board_painter.png";
import wall_advertising from "../assets/ravindran_img/wall_advertising.jpg";
import wall_advertising1 from "../assets/ravindran_img/wall_advertising1.jpg";
import name_plate from "../assets/ravindran_img/name_plate.jpg";
import shop_sign_board from "../assets/ravindran_img/shop_sign_board.jpg";
import customer01 from "../assets/ravindran_img/customer01.jpg";
import dummy_customer from "../assets/ravindran_img/dummy_customer.jpeg";
import googleMap from "../assets/Google_Maps_logo.png";

const images = {
  customer01,
  dummy_customer,

  building_name_board,
  building_name_board02,
  building_name_board01,
  building_name_board03,
  building_name_board04,
  banner,
  sign_board_painter,
  wall_advertising,
  wall_advertising1,
  name_plate,
  shop_sign_board,
  eng_hindi_marathi_service,

  call,
  gmail,
  telegram,
  whatsapp,
  email,
  mobile,
  api,
  cpp,
  css,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  mu5,
  node,
  python,
  react,
  redux,
  sass,
  typescript,
  vue,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  logo,
  adidas,
  amazon,
  asus,
  bolt,
  nb,
  skype,
  spotify,
  googleMap,
};

export default images;
